import { createFileRoute } from '@tanstack/react-router'
import { McpManagementPage } from '@/pages/mcp-management/mcp-management-page'

export const Route = createFileRoute('/settings/mcp')({
  component: McpManagementPage,
})
